import { useState } from "react";
import ConfirmationModal from "../../../../component/modal/Confirmation";
import { RadioButtonCard } from "../../../../component/RadioButtonCard/RadioButtonCard";
import { SelectButton } from "../../../../SelectButton/SelectButton";
import { useIgluAnalyticsStore } from "../../../../store/useIgluAnalyticsStore";
import { datesToFilter } from "../datesToFilter/datesToFilter";

export function FilterDate() {
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const { dateToFilter, setDateToFilter } = useIgluAnalyticsStore();

  const dateOptions = Object.entries(datesToFilter).map(
    ([key, data], index) => ({
      value: key,
      label: data.label,
      placeholder: data.placeholder,
      id: index,
    }),
  );

  const [selectedOption, setSelectedOption] = useState(dateToFilter);

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
  };

  const handleOptionChange = (value) => {
    setSelectedOption(value);
  };

  const handleConfirmation = () => {
    setDateToFilter(selectedOption);
    closeConfirmationModal();
  };

  return (
    <>
      <SelectButton
        text={
          dateOptions.find((option) => option.value === dateToFilter)?.label ||
          dateOptions[0].label
        }
        onClick={openConfirmationModal}
      />
      <ConfirmationModal
        isOpen={isConfirmationModalOpen}
        onClose={closeConfirmationModal}
        title="Filtrar por data"
        prompt={dateOptions.map((option) => (
          <RadioButtonCard
            key={option.id}
            label={option.label}
            helpText={option.placeholder}
            value={option.value}
            onChange={() => handleOptionChange(option.value)}
            checked={option.value === selectedOption}
          />
        ))}
        confirmText="Confirmar"
        cancelText="Cancelar"
        onConfirm={handleConfirmation}
        onCancel={() => {
          closeConfirmationModal();
        }}
      />
    </>
  );
}
